import { createWithEqualityFn } from 'zustand/traditional';
import { persistForUser } from '@erikdakoda/ui/shared/persistForUser';

interface State {
  artifactsSidebarOpen: boolean;
  artifactFilter: string;
  artifactsRefreshToken: number;
}

interface Action {
  setArtifactsSidebarOpen: (artifactsSidebarOpen: State['artifactsSidebarOpen']) => void;
  setArtifactFilter: (artifactFilter: State['artifactFilter']) => void;
  bumpArtifactsRefresh: () => void;
}

export const useArtifactsSidebarStore = createWithEqualityFn<State & Action>()(
  persistForUser(
    (set) => ({
      artifactsSidebarOpen: false,
      artifactFilter: '',
      artifactsRefreshToken: 0,

      setArtifactsSidebarOpen: (artifactsSidebarOpen) => set(() => ({ artifactsSidebarOpen })),
      setArtifactFilter: (artifactFilter) => set(() => ({ artifactFilter })),
      bumpArtifactsRefresh: () =>
        set((state) => ({ artifactsRefreshToken: state.artifactsRefreshToken + 1 })),
    }),
    {
      name: 'artifacts-sidebar-store',
      partialize: (state) => ({
        artifactsSidebarOpen: state.artifactsSidebarOpen,
        artifactFilter: state.artifactFilter,
      }),
    },
  ),
);
